import { useParams } from 'react-router';
import { Card } from 'reactstrap';
import { StudentWarningsSummaryDetailsFormLoader } from './loaders/StudentWarningsSummaryDetailsFormLoader';
import { StudentWarningsSummaryDetailsLoader } from './loaders/StudentWarningsSummaryDetailsLoader';
import StudentWarningsSummaryDetailsBlocks from './parts/StudentWarningsSummaryDetailsBlocks';
import StudentWarningsSummaryDetailsBox from './parts/StudentWarningsSummaryDetailsBox';
import StudentWarningsSummaryDetailsFilters from './parts/StudentWarningsSummaryDetailsFilters';
import StudentWarningsSummaryTabs from './parts/StudentWarningsSummaryDetailsTabs';
import { StudentWarningsSummaryDetailsParams } from './types';

const StudentWarningsDetails = () => {
  const params = useParams<StudentWarningsSummaryDetailsParams>();

  return (
    <div className="mx-3">
      <Card className="p-4">
        <div className="w-100 d-flex flex-wrap justify-content-center">
          <StudentWarningsSummaryDetailsFormLoader fetchImmediately>
            <StudentWarningsSummaryDetailsLoader
              defaultQuery={{
                ...params,
                startAt:
                  params?.startAt !== 'NULL' ? params.startAt : undefined,
                endAt: params?.endAt !== 'NULL' ? params.endAt : undefined,
              }}
              fetchImmediately
            >
              <StudentWarningsSummaryDetailsBox />
              <StudentWarningsSummaryDetailsFilters />
              <StudentWarningsSummaryDetailsBlocks />
              <StudentWarningsSummaryTabs />
            </StudentWarningsSummaryDetailsLoader>
          </StudentWarningsSummaryDetailsFormLoader>
        </div>
      </Card>
    </div>
  );
};

export default StudentWarningsDetails;
